import config from "@Config/index";
import axios from "axios";

// eslint-disable-next-line import/prefer-default-export
export const createLead = async (params: any, options = {}) => {
  try {
    const { data } = await axios.post(
      `${config.API_URL}/api/v0/leads/`,
      {
        lead: params.lead,
        ...options,
      },
      {
        withCredentials: true,
      },
    );
    return { ...data };
  } catch (error: any) {
    return { error };
  }
};

export const updateLead = async (id: string, params: any) => {
  try {
    const { data } = await axios.put(
      `${config.API_URL}/api/v0/leads/${id}`,
      {
        ...params,
      },
      {
        withCredentials: true,
      },
    );
    return { ...data };
  } catch (error: any) {
    return { error };
  }
};

export const getLeadData = async (id: string, params: any) => {
  try {
    const { data } = await axios.get(`${config.API_URL}/api/v0/leads/${id}`, { params });
    return { ...data };
  } catch (error: any) {
    return { error };
  }
};
